// THIS FILE IS AUTO-GENERATED FROM dataportal.yml
// DO NOT EDIT MANUALLY - Run 'yarn analytics:generate' to regenerate

import type {
  FeatureEvents as BaseFeatureEvents,
  UIEvent as BaseUIEvent,
  ScreenEvent,
} from './types';
import { Action, ActionSubject } from './types';

// Attribute types

// Screen definitions
export const screens = {
  appUpdatesListScreen: 'appUpdatesListScreen',
  appUpdatesDetailsScreen: 'appUpdatesDetailsScreen',
} as const;

export type Screen = (typeof screens)[keyof typeof screens];

type ActionSubjectId = `appUpdates${string}`;

type UIEvent = {
  data: Omit<BaseUIEvent['data'], 'actionSubjectId'> & {
    actionSubjectId: ActionSubjectId;
    source: Screen;
  };
} & Omit<BaseUIEvent, 'data'>;

type FeatureEventsType = Omit<
  BaseFeatureEvents<Screen, string, never, never>,
  'ui' | 'screen'
> & {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-unused-vars
  ui: Record<string, (...args: any[]) => UIEvent>;
  // Screen events can be static objects or functions that return a ScreenEvent (for screens with attributes)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-unused-vars
  screen: Record<Screen, ScreenEvent | ((...args: any[]) => ScreenEvent)>;
};

export const appUpdatesUIEvents = {
  screen: {
    appUpdatesListScreen: {
      data: {
        name: screens.appUpdatesListScreen,
      },
    },
    /**
     * Detail screen event with changelogId and optional updatesAppTypes attributes
     * for tracking which release notes are viewed and by which app type
     */
    appUpdatesDetailsScreen: (
      changelogId: string,
      updatesAppTypes?: string,
    ) => ({
      data: {
        name: screens.appUpdatesDetailsScreen,
        attributes: {
          changelogId,
          ...(updatesAppTypes && { updatesAppTypes }),
        },
      },
    }),
  },

  ui: {
    /**
     * User clicked the app filter on the app updates list screen
     */
    appUpdatesAppFilterClicked: (
      data: { source: Screen },
      updatesAppTypes?: string,
    ) => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'appUpdatesAppFilter',
        ...data,
        attributes: {
          ...(updatesAppTypes && { updatesAppTypes }),
        },
      },
    }),
    /**
     * User clicked the status filter on the app updates list screen
     */
    appUpdatesStatusFilterClicked: (
      data: { source: Screen },
      updatesStatusTypes?: string,
    ) => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'appUpdatesStatusFilter',
        ...data,
        attributes: {
          ...(updatesStatusTypes && { updatesStatusTypes }),
        },
      },
    }),
    /**
     * User clicked the type filter on the app updates list screen
     */
    appUpdatesTypeFilterClicked: (
      data: { source: Screen },
      updatesChangeTypes?: string,
    ) => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'appUpdatesTypeFilter',
        ...data,
        attributes: {
          ...(updatesChangeTypes && { updatesChangeTypes }),
        },
      },
    }),
    /**
     * User clicked the apply button on the app updates list screen
     */
    appUpdatesApplyClicked: (
      data: { source: Screen },
      updatesAppTypes?: string,
      updatesStatusTypes?: string,
      updatesChangeTypes?: string,
      updatesSearchContent?: string,
    ) => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'appUpdatesApply',
        ...data,
        attributes: {
          ...(updatesAppTypes && { updatesAppTypes }),
          ...(updatesStatusTypes && { updatesStatusTypes }),
          ...(updatesChangeTypes && { updatesChangeTypes }),
          ...(updatesSearchContent && { updatesSearchContent }),
        },
      },
    }),
  },

  track: {},
  operational: {},
} satisfies FeatureEventsType;
